// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Reference_wrapper__MssDl","content":"Reference_content__dUQ1s","item":"Reference_item__5ri9d","arrow":"Reference_arrow__1oSZo"};